import { OPTIONS_INTEGRATION } from 'app-constants'
import { http, normalizeResponse } from 'hooks'

export function serviceOrderService() {
  function getServiceOrderContractEligible(contractId) {
    return http.get(`v1/service-orders/eligible?contractId=${contractId}`, OPTIONS_INTEGRATION)
  }

  function updateServiceOrder(serviceOrderId, params) {
    return http.put(`/v1/bookings/${serviceOrderId}`, params, OPTIONS_INTEGRATION)
  }

  function getServiceOrders(contractId) {
    return http.get(`/v1/service-orders/${contractId}`, OPTIONS_INTEGRATION)
  }

  function getServiceOrderDetails(contractId, type) {
    return http.get(
      `/v1/service-orders/${contractId}/detail?serviceOrderType=${type}`,
      OPTIONS_INTEGRATION
    )
  }

  function putCancelServiceOrder(params) {
    return http.put('/v1/service-orders/cancel', params, OPTIONS_INTEGRATION)
  }

  function getVisitTrackingLink(osId) {
    return http.get(`/v1/service-orders/${osId}/tracking`, OPTIONS_INTEGRATION)
  }

  function postConfirmeServiceSchedule(serviceOrderId, scheduleDate) {
    return http.post(
      `/v1/service-orders/confirm`,
      { serviceOrderId, scheduleDate },
      OPTIONS_INTEGRATION
    )
  }

  function getServiceProtocolHistory() {
    return http.get(`/v1/contracts/services/protocols`, {
      ...OPTIONS_INTEGRATION,
    })
  }

  function getServiceOrderSupportStatus(contractId, areaCode) {
    return http.get('v1/service-orders/support-status', {
      params: {
        contractId,
        areaCode,
      },
      ...OPTIONS_INTEGRATION,
    })
  }

  async function checkServiceOrderActive(contractId, serviceOrderType) {
    return http
      .get('/app/v1/service-orders/check', {
        params: {
          contractId,
          serviceOrderType,
        },
        ...OPTIONS_INTEGRATION,
      })
      .then(normalizeResponse)
  }

  return {
    getServiceOrderContractEligible,
    updateServiceOrder,
    getServiceOrders,
    getServiceOrderDetails,
    putCancelServiceOrder,
    getVisitTrackingLink,
    postConfirmeServiceSchedule,
    getServiceProtocolHistory,
    getServiceOrderSupportStatus,
    checkServiceOrderActive,
  }
}
